import sig_in_bg from '../assets/auth/auth-bg.jpg';
import search_icon from '../assets/icons/search loop.png';
import logo from '../assets/icons/logo-fiscalbox.svg';
import logo_hat from '../assets/icons/christmas-icons/logo-fiscalbox-hat.svg';
import arrow_down from '../assets/icons/arrow down.svg'
import manage_account from '../assets/icons/manage-acc-icon.svg'
import activity_log from '../assets/icons/activity-log-icon.svg'
import logout from '../assets/icons/log-out-icon.svg'
import defaultAvatar from '../assets/images/default-user-avatar.png';
import defaultAvatar2 from '../assets/images/default-user-avatar-1.png';
import greyAvatar from '../assets/icons/christmas-icons/grey-user.jpeg';
import deviceRegistrationBanner from '../assets/images/device-registration-banner.jpg';
import s2pLightTheme from '../assets/images/s2p-themes/s2p-light.png';
import s2pCreamTheme from '../assets/images/s2p-themes/s2p-cream.png';
import s2pDarkTheme from '../assets/images/s2p-themes/s2p-dark.png';
import deviceTotal from '../assets/icons/devices/filled/active-multi-icon.svg';
import deviceActive from '../assets/icons/devices/filled/activity-green-icon.svg';
import deviceInactiveDay from '../assets/icons/devices/filled/activity-red-icon.svg';
import deviceInactiveHour from '../assets/icons/devices/filled/activity-orange-icon.svg';
import deviceInactiveMinute from '../assets/icons/devices/filled/activity-blue-icon.svg';
import newLogo from '../assets/icons/new_logo.png';
import paymeLogo from '../assets/icons/providers/payme_icon.svg';
import clickLogo from '../assets/icons/providers/click_icon.svg';
import anorLogo from '../assets/icons/providers/anorbank_icon.svg';
import uzumLogo from '../assets/icons/providers/uzum_icon.svg';
import uzQrLogo from '../assets/icons/providers/uz_qr_icon.png';
import logoFboxNoFrame from '../assets/icons/logo-fbox-no-frame.svg';
import paxTerminalIcon from '../assets/icons/terminals/pax_terminal.png';
import ingenicoTerminalIcon from '../assets/icons/terminals/ingenico_terminal.png';
import christmasLogo from '../assets/icons/christmas-icons/christmas-fiscalbox-logo.svg';
import fiscalboxDeviceCount from '../assets/icons/companies/fiscalbox_icon.png';
import fiscalboxMapCard from '../assets/images/fiscalbox-map-card.jpeg';
import servercoreLogo from '../assets/icons/servercore-logo.png';

export const images = {
    sig_in_bg,
    search_icon,
    logo,
    logo_hat,
    arrow_down,
    manage_account,
    activity_log,
    logout,
    defaultAvatar,
    defaultAvatar2,
    greyAvatar,
    deviceRegistrationBanner,
    s2pLightTheme,
    s2pCreamTheme,
    s2pDarkTheme,
    deviceTotal,
    deviceActive,
    deviceInactiveDay,
    deviceInactiveHour,
    deviceInactiveMinute,
    newLogo,
    paymeLogo,
    clickLogo,
    anorLogo,
    uzumLogo,
    uzQrLogo,
    logoFboxNoFrame,
    paxTerminalIcon,
    ingenicoTerminalIcon,
    christmasLogo,
    fiscalboxDeviceCount,
    fiscalboxMapCard,
    servercoreLogo
}
